import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Image, Row, Button } from "react-bootstrap";
import moment from "moment";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputBase,
  InputLabel,
  OutlinedInput,
  Paper,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CallingButtonPopup from "../../reusableComponents/allPopupReusable/CallingButtonPopup";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import Loader from "react-loader-spinner";
import Media from "react-media";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import MarkAsReadIcon from "../../../assets/images/UserManagement/mark.svg";
import SocketContext from "../../../function/SocketContext";
import CloseIcon from "@material-ui/icons/Close";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  create_chat_vendor_user,
  get_multiple_chat_vendor_user,
  get_single_chat_vendor_user,
  update_mark_all_chat_vendor_user,
} from "../../../store/actions/notificationAction/notificationActions";
import isEmpty from "../../../store/validation/is-Empty";
import {
  UPDATE_CHAT_INFO,
  UPDATE_MULTIPLE_CHAT_INFO,
  GET_CHAT_INFO,
} from "../../../store/types";
import { ORDER_ICONS, ORDER_TYPE_NAME } from "../../../enums/OrderEnums";
import {
  NOTAVAILABLEIMAGE,
  WALKIN_ICON,
  WAITLIST_ICON,
  RESERVATION_ICON,
  EVENT_RSVP_ICON,
  EVENT_TICKET_ICON,
} from "../../../enums/GlobalEnums";
import LOGO_MAIN from "../../../assets/images/logo.png";

const SeatingImage = require("../../../assets/images/seatingImages/newseaticon.svg");
const PendingImage = require("../../../assets/images/ActionImages/image/waitlist.svg");
const ReservationImage = require("../../../assets/images/seatingImages/newreservationicon.svg");
const OrderImage = require("../../../assets/images/ActionImages/image/reservation.svg");
const EventImage = require("../../../assets/images/ActionImages/image/reservation.svg");
const AdminImage = require("../../../assets/images/ActionImages/image/reservation.svg");

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const ChatVendorDashboardScreen = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    search: "",
    messageText: "",
  });

  const onSearchChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId =
      props.vendorAccess?.vendor_id || props.auth.user.VendorUser._id;
    props.get_multiple_chat_vendor_user(vendorId, token);
  }, [!props.multipleUserChat]);

  const [allChatData, setAllChatData] = useState([]);
  useEffect(() => {
    setAllChatData(props.multipleUserChat);
  }, [props.multipleUserChat]);

  const [singleChatUser, setSingleChatUser] = useState([]);
  useEffect(() => {
    setSingleChatUser(props.singleUserChat && props.singleUserChat.messages);
  }, [props.singleUserChat]);

  useEffect(() => {
    props.socket.service("chat").on("created", async (data) => {
      dispatch({ type: UPDATE_CHAT_INFO, payload: data });
      dispatch({ type: UPDATE_MULTIPLE_CHAT_INFO, payload: data });
    });
  }, []);

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onClickClosedChat = (e) => {
    dispatch({ type: GET_CHAT_INFO, payload: {} });
  };

  const onSubmitMessage = (e) => {
    const token = props.auth.user.accessToken;
    const formData = {
      vendor: props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id,
      restaurant: props.onboarding._id,
      message: state.messageText,
      sentBy: "VENDOR",
    };
    if (props.singleUserChat.chatType === "GENERAL") {
      formData.admin = props.singleUserChat.admin._id;
    } else {
      formData.user = props.singleUserChat.user._id;
    }
    if (props.singleUserChat.chatType === "DINER") {
      formData.diner = props.singleUserChat?.diner?._id;
    } else if (props.singleUserChat.chatType === "ORDER") {
      formData.order = props.singleUserChat?.order?._id;
    } else if (props.singleUserChat.chatType === "EVENT") {
      formData.event = props.singleUserChat?.event?._id;
    }
    props.create_chat_vendor_user(formData, token, (data) => onSuccess(data));
  };

  const onSuccess = (data) => {
    setState({
      ...state,
      messageText: "",
    });
    dispatch({ type: UPDATE_CHAT_INFO, payload: data });
    dispatch({ type: UPDATE_MULTIPLE_CHAT_INFO, payload: data });
  };

  const onSingleChatGetClick = (e, chatData) => {
    const token = props.auth.user.accessToken;
    let vendor_id =
      props?.vendorAccess?.vendor_id || props?.auth.user.VendorUser._id;
    let id = chatData._id;
    props.get_single_chat_vendor_user({ vendor: vendor_id, id: id }, token);
  };

  /***********************
   * @DESC Mark All Read
   **********************/
  const onMarkasReadAll = (e) => {
    const token = props.auth.user.accessToken;
    let vendorId =
      props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id;
    const formData = {
      vendor: vendorId,
      type: "MARKREAD",
    };
    props.update_mark_all_chat_vendor_user(
      formData,
      token,
      onMarkCompletedSuccess
    );
  };

  const onMarkCompletedSuccess = () => {
    const token = props.auth.user.accessToken;
    const vendorId =
      props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id;
    props.get_multiple_chat_vendor_user(vendorId, token);
  };

  const allUserChatData = (singleChat) => {
    const allUserData = allChatData;
    let latestChatText = "";
    let filterData = [];

    if (state.search) {
      let search = new RegExp(state.search, "i");
      filterData = allUserData.filter((getall) => {
        if (
          search.test(
            getall &&
              getall.user &&
              getall.user[0] &&
              getall.user[0].first_name + " " + getall.user[0].last_name
          )
        ) {
          return getall;
        } else if (
          search.test(
            getall &&
              getall.diner &&
              getall.diner[0] &&
              getall.diner[0].diner_id
          )
        ) {
          return getall;
        } else if (
          search.test(
            getall &&
              getall.user &&
              getall.user[0] &&
              getall.user[0].mobile_number[0]
          )
        ) {
          return getall;
        } else if (
          search.test(
            getall && getall.user && getall.user[0] && getall.user[0].email
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    } else {
      filterData = allUserData;
    }
    if (!isEmpty(filterData)) {
      return filterData.map(
        (chatData, index) => (
          (latestChatText =
            chatData &&
            chatData.messages.findIndex(
              (message) => message.sentBy === "USER" && message.read === false
            )),
          (
            <React.Fragment key={index}>
              <div
                className={`mt-3 ch-lt-s-box ${
                  chatData?.diner?.userConfirmed
                    ? "ch-lt-s-box-b-g"
                    : "ch-lt-s-box-b-o"
                }  ${
                  singleChat._id && singleChat._id === chatData._id
                    ? "ch-lt-box-b-Active"
                    : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={(e) => onSingleChatGetClick(e, chatData)}
              >
                {/* ch-lt-s-box-b-o */}
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    className="text-center"
                    style={{
                      width: "13%",
                      borderRadius: "50px",
                      minHeight: "30px",
                    }}
                  >
                    <Image
                      src={
                        chatData?.diner?.service_type === "SEATING"
                          ? chatData?.diner !== null &&
                            chatData?.diner !== undefined
                            ? WALKIN_ICON
                            : NOTAVAILABLEIMAGE
                          : chatData?.diner?.service_type === "RESERVATION"
                          ? chatData?.diner !== null &&
                            chatData?.diner !== undefined
                            ? RESERVATION_ICON
                            : NOTAVAILABLEIMAGE
                          : chatData?.chatType === "ORDER"
                          ? chatData?.order !== null &&
                            chatData?.order !== undefined
                            ? ORDER_ICONS[chatData?.order?.order_type]
                            : NOTAVAILABLEIMAGE
                          : chatData?.chatType === "EVENT"
                          ? chatData?.event !== null &&
                            chatData?.event !== undefined
                            ? chatData?.event?.event_type === "RSVP"
                              ? EVENT_RSVP_ICON
                              : EVENT_TICKET_ICON
                            : NOTAVAILABLEIMAGE
                          : chatData?.chatType === "GENERAL"
                          ? LOGO_MAIN
                          : ""
                      }
                      alt={
                        chatData?.diner?.service_type === "SEATING"
                          ? chatData?.diner !== null &&
                            chatData?.diner !== undefined
                            ? "Walkin Service"
                            : "N/A"
                          : chatData?.diner?.service_type === "RESERVATION"
                          ? chatData?.diner !== null &&
                            chatData?.diner !== undefined
                            ? "Reservation Service"
                            : "N/A"
                          : chatData?.chatType === "ORDER"
                          ? chatData?.order !== null &&
                            chatData?.order !== undefined
                            ? `${
                                ORDER_TYPE_NAME[chatData?.order?.order_type]
                              } Service`
                            : "N/A"
                          : chatData?.chatType === "EVENT"
                          ? chatData?.event !== null &&
                            chatData?.event !== undefined
                            ? chatData?.event?.event_type === "RSVP"
                              ? "RSVP Event"
                              : "Event Ticket"
                            : "N/A"
                          : chatData?.chatType === "GENERAL"
                          ? "Admin"
                          : ""
                      }
                      title={
                        chatData?.diner?.service_type === "SEATING"
                          ? chatData?.diner !== null &&
                            chatData?.diner !== undefined
                            ? "Walkin Service"
                            : "N/A"
                          : chatData?.diner?.service_type === "RESERVATION"
                          ? chatData?.diner !== null &&
                            chatData?.diner !== undefined
                            ? "Reservation Service"
                            : "N/A"
                          : chatData?.chatType === "ORDER"
                          ? chatData?.order !== null &&
                            chatData?.order !== undefined
                            ? `${
                                ORDER_TYPE_NAME[chatData?.order?.order_type]
                              } Service`
                            : "N/A"
                          : chatData?.chatType === "EVENT"
                          ? chatData?.event !== null &&
                            chatData?.event !== undefined
                            ? chatData?.event?.event_type === "RSVP"
                              ? "RSVP Event"
                              : "Event Ticket"
                            : "N/A"
                          : chatData?.chatType === "GENERAL"
                          ? "Admin"
                          : ""
                      }
                      fluid
                      // className="rs-ser-w"
                      style={{
                        borderRadius: `${
                          chatData?.chatType === "GENERAL" ? "0px" : "50px"
                        }`,
                        height: "50px",
                        width: "100%",
                        padding: `${
                          chatData?.chatType === "GENERAL" ? "5px" : "0px"
                        }`,
                      }}
                    />
                  </div>
                  <div className="w-75 d-flex align-items-center">
                    <div
                      // className="user-pro-w"
                      style={{
                        width: "20%",
                        borderRadius: "50px",
                        // minHeight: "30px",
                        padding: "5px",
                      }}
                    >
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <Image
                            src={
                              chatData?.user?.profile_photo?.length > 0
                                ? chatData?.user?.profile_photo?.[0]
                                : NOTAVAILABLEIMAGE
                            }
                            alt="User Profile"
                            title="User Profile"
                            fluid
                            roundedCircle
                            // className="rs-ser-w"
                            style={{
                              height: "48px",
                              width: "100%",
                            }}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    </div>
                    <div className="pl-2 pr-2" style={{ width: "80%" }}>
                      {chatData?.chatType !== "GENERAL" ? (
                        <p
                          className={`${
                            latestChatText >= 0 ? "f11-700" : "f11-400"
                          }`}
                        >
                          {chatData?.user?.first_name ||
                            "" + " " + chatData?.user?.last_name ||
                            ""}
                        </p>
                      ) : (
                        <p
                          className={`${
                            latestChatText >= 0 ? "f11-700" : "f11-400"
                          }`}
                        >
                          {(chatData?.user?.first_name || "Super") +
                            " " +
                            (chatData?.user?.last_name || "Admin")}
                        </p>
                      )}
                      {chatData?.chatType !== "GENERAL" && (
                        <p className="f9-400 mt-1">
                          #
                          {chatData.chatType === "DINER"
                            ? chatData.diner?.diner_id
                            : chatData.chatType === "EVENT"
                            ? chatData.event?.event_id?.event_id
                            : chatData.chatType === "ORDER"
                            ? chatData.order?.order_id
                            : ""}
                        </p>
                      )}

                      <React.Fragment>
                        <p
                          className={`${
                            latestChatText >= 0 ? "f11-700" : "f10-400"
                          } mt-2`}
                        >
                          {
                            chatData.messages[chatData?.messages.length - 1]
                              .message
                          }
                          <br />
                        </p>
                      </React.Fragment>
                    </div>
                  </div>
                  <div
                    className="text-center align-self-start"
                    style={{ width: "12%" }}
                  >
                    <p className="f9-500">
                      {/* {latestChatText &&
                        latestChatText.map((data, index) => {
                          return ( */}
                      <React.Fragment>
                        {moment(
                          chatData.messages[chatData?.messages.length - 1].date
                        ).format("HH:mm")}
                      </React.Fragment>
                      {/* ); */}
                      {/* })} */}
                    </p>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
        )
      );
    } else {
      return null;
    }
  };

  let userInfo = {
    user_details: {
      mobile_number:
        props.singleUserChat &&
        props.singleUserChat.user &&
        props.singleUserChat.user.mobile_number,
      country_code:
        props.singleUserChat &&
        props.singleUserChat.user &&
        props.singleUserChat.user.country_code,
      name:
        props.singleUserChat &&
        props.singleUserChat.user &&
        props.singleUserChat.user.first_name +
          " " +
          props.singleUserChat.user.last_name,
    },
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <Media query="(min-width: 992px)">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
          </Media>
          <div className="mobile-right-side-panel super-admin-right-side-panel chat-box-dashboard">
            <div className="super-admin-inside-right-side-panel">
              <RightSideNavigation displayButton="addEvent" />
            </div>
            <div className="col-12">
              <div className="row">
                <div
                  id="style-4"
                  className="col-4"
                  style={{ maxHeight: "90vh", overflowX: "hidden" }}
                >
                  {/******************
                   * @DESC Search Bar
                   *******************/}
                  <div className="col-12">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        className="w-100"
                        inputProps={{
                          placeholder: "Search by user name, request type",
                          name: "search",
                        }}
                        onChange={(e) => onSearchChange(e)}
                        value={state.search}
                      />
                    </Paper>
                  </div>
                  {/******************
                   * @DESC Mark Read
                   *******************/}
                  <div className="col-12 mt-2">
                    <div
                      className="d-flex justify-content-between align-items-center px-3 py-1"
                      style={{
                        backgroundColor: "#FFF2D5",
                        borderRadius: "5px",
                      }}
                    >
                      <div>
                        <p className="f11-700">Chats</p>
                      </div>
                      <div
                        className="action-button text-center"
                        onClick={onMarkasReadAll}
                      >
                        <div>
                          <img
                            src={MarkAsReadIcon}
                            alt="Mark Read"
                            title="Mark Read"
                            style={{ width: "35%", height: "auto" }}
                          />
                        </div>
                        <div>
                          <span className="f9-400 w-100 mt-2">
                            Mark All Read
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/******************
                   * @DESC All Chat Box
                   *******************/}
                  <div className="col-12">
                    {props.auth.loader ? (
                      <Loader
                        type="ThreeDots"
                        color="#00BFFF"
                        height={25}
                        width={25}
                      />
                    ) : (
                      allUserChatData(props.singleUserChat)
                    )}
                  </div>
                </div>
                {singleChatUser && singleChatUser.length > 0 ? (
                  <div className="col-8">
                    <div
                      className="col-12 p-0"
                      style={{ boxShadow: "0px 0px 20px rgba(0,0,0,0.19)" }}
                    >
                      <div
                        style={{ backgroundColor: "#F8F8F8" }}
                        className="col-12 p-3"
                      >
                        <div className="row align-items-center">
                          <div className="col-11 d-flex align-items-center">
                            <div style={{ width: "6%" }}>
                              <SimpleReactLightbox>
                                <SRLWrapper options={options}>
                                  <Image
                                    src={
                                      props?.singleUserChat?.user?.profile_photo
                                        ?.length > 0
                                        ? props?.singleUserChat?.user
                                            ?.profile_photo
                                        : NOTAVAILABLEIMAGE
                                    }
                                    fluid
                                    alt="Profile Logo"
                                    title="Profile Logo"
                                    className="rounded-circle"
                                    style={{ width: "50px", height: "50px" }}
                                  />
                                </SRLWrapper>
                              </SimpleReactLightbox>
                            </div>
                            <div className="pl-3">
                              <div className="f12-500">
                                {props.singleUserChat?.chatType === "GENERAL"
                                  ? "Super Admin"
                                  : props.singleUserChat &&
                                    props.singleUserChat.user &&
                                    props.singleUserChat.user.first_name +
                                      " " +
                                      props.singleUserChat.user.last_name}
                              </div>
                              <div
                                className="f10-400"
                                style={{ color: "#757575" }}
                              >
                                {props?.singleUserChat?.chatType === "DINER"
                                  ? `#${props?.singleUserChat?.diner?.diner_id}`
                                  : props?.singleUserChat?.chatType === "EVENT"
                                  ? `#${props?.singleUserChat?.event?.event_id?.event_id}`
                                  : props?.singleUserChat?.chatType === "ORDER"
                                  ? `#${props?.singleUserChat?.order?.order_id}`
                                  : ""}
                              </div>
                            </div>
                            <div className="pl-4">
                              <CallingButtonPopup
                                buttonClass="smallButton"
                                actionBy={"ADMIN"}
                                sendData={userInfo && userInfo}
                              />
                            </div>
                          </div>
                          <div className="col-1">
                            <button
                              className="btn btn-light bg-transparent"
                              style={{ border: "none" }}
                              onClick={onClickClosedChat}
                              type="button"
                              title="Close"
                            >
                              <CloseIcon />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-12"
                        style={{ backgroundColor: "#FFFFFF" }}
                      >
                        <div className="py-4" style={{ minHeight: "462px" }}>
                          {!isEmpty(singleChatUser) &&
                            singleChatUser.map((chat, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {chat.sentBy === "VENDOR" ? (
                                    <RightSideMsg
                                      content={chat.message}
                                      source={
                                        chat.sentBy === "ADMIN"
                                          ? "Admin"
                                          : chat.sentBy === "VENDOR"
                                          ? "You"
                                          : "User"
                                      }
                                      date={moment(chat.date).format(
                                        "hh:mm A, Do MMM YYYY"
                                      )}
                                    />
                                  ) : (
                                    <LeftSideMsg
                                      content={chat.message}
                                      source={
                                        chat.sentBy === "ADMIN"
                                          ? "Admin"
                                          : chat.sentBy === "VENDOR"
                                          ? "You"
                                          : "User"
                                      }
                                      date={moment(chat.date).format(
                                        "hh:mm A, Do MMM YYYY"
                                      )}
                                    />
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </div>
                        <div className="row">
                          <div className="col-12 p-3 border-top border-bottom">
                            <FormControl className={"w-100"} variant="outlined">
                              <Row>
                                <Col md={props.auth.secondary_loader ? 11 : 12}>
                                  <InputLabel
                                    htmlFor="outlined-Mobile"
                                    className="pl-4"
                                  >
                                    Write your message
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    name="messageText"
                                    value={state.messageText}
                                    onChange={onChange}
                                    id="outlined-msg"
                                    className="w-100"
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          edge="end"
                                          onClick={onSubmitMessage}
                                        >
                                          <span
                                            className="chat-button-box-button"
                                            style={{
                                              background: "#EE3A23",
                                              color: "white",
                                              borderRadius: "5px",
                                              padding: "5px",
                                              fontSize: "20px",
                                            }}
                                          >
                                            <i
                                              className="font-awesome-flag-size fa fa-paper-plane-o"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                          {/* <SendIcon /> */}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    labelWidth={155}
                                  />
                                </Col>
                                <Col md={props.auth.secondary_loader ? 1 : 0}>
                                  {props.auth.secondary_loader ? (
                                    <Loader
                                      type="ThreeDots"
                                      color="#00BFFF"
                                      height={25}
                                      width={25}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              </Row>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ChatVendorDashboardScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  onboarding: state.onboarding.restaurantDetails,
  singleUserChat: state.notifications.chatInfo,
  multipleUserChat: state.notifications.multipleChatInfo,
  auth: state.auth,
  errors: state.errors.errors,
  vendorAccess: state.vendorAccess,
});

const ChatVendorDashboard = (props) => (
  <SocketContext.Consumer>
    {(socket) => <ChatVendorDashboardScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
  create_chat_vendor_user,
  get_single_chat_vendor_user,
  get_multiple_chat_vendor_user,
  update_mark_all_chat_vendor_user,
})(withRouter(ChatVendorDashboard));

const RightSideMsg = (props) => {
  return (
    <React.Fragment>
      <>
        <div className="row mb-3">
          <Col xs={5}></Col>
          <Col xs={7}>
            <div
              style={{
                backgroundColor: "#FFB116",
                borderRadius: "5px 5px 0px 5px",
              }}
              className=" p-2"
            >
              <div className="f11-400 text-white">{props.content}</div>
            </div>
            {props.date && (
              <div className="f10-700 mt-1" align="right">
                <span style={{ color: "#9E9E9E" }} className="f10-400">
                  {props.date} |{" "}
                </span>
                {props.source}
              </div>
            )}
          </Col>
        </div>
      </>
    </React.Fragment>
  );
};

const LeftSideMsg = (props) => {
  return (
    <React.Fragment>
      <>
        <div className="row mb-3">
          <Col xs={7}>
            <div
              style={{
                backgroundColor:
                  props.source === "Admin" ? "#42B5FC" : "#E6E6E6",
                borderRadius: "5px 5px 5px 0px",
              }}
              className=" p-2"
            >
              <div className="f11-400">{props.content}</div>
            </div>
            {props.date && (
              <div className="f10-700 mt-1" align="left">
                <span style={{ color: "#9E9E9E" }} className="f10-400">
                  {props.date} |{" "}
                </span>
                | {props.source}
              </div>
            )}
          </Col>
          <Col xs={5}></Col>
        </div>
      </>
    </React.Fragment>
  );
};
